<template >
<div id="diario" >
  <v-container grid-list-md text-xs-center>

        <v-flex xs12>
<base-material-card color="primary" icon="library_books" title="Reportes Anexo24" class="elevation-1 px-5 py-3">
    <v-container fluid fill-height >
            <v-layout align-center justify-center>
                <v-flex xs12>
                    <div class="iframe-container">
                        <iframe id="myIframe" :src="url"   ></iframe>
                    </div>

                </v-flex>
            </v-layout>
    
       
    </v-container>
     </base-material-card>
           </v-flex>

    </v-container>
</div>
</template>

<script>
import moment from "moment";

export default {
    components: {

    },

    data: () => ({

        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Reportes Anexo 24",
                disabled: true,
                to: ""
            },
        ],
       url: ""
     
     

    }),

    created() {
      let mail = this.$local_storage.get("email");
        this.url = "https://integra24.mx/A24/ReportesA24U?USU=" + mail ;
    },
    methods: {
    
       
    }

};
</script>

<style scoped>
.iframe-container {

    padding-top: 56.25%;
    position: relative;
    overflow: hidden;
   
}

.iframe-container iframe {
    border: 0;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
}
</style>
